import { secureFetch } from './auth'
import { failureMessage, HttpError } from './orders-api'

/** bench-SWITCH-SAYS-WHAT-MOVES.CB-E §1④ -- the switch-preview response shape. */
export interface SwitchPreview {
  masterCustomerId: string
  customerName: string | null
  toEntity: 'TKF' | 'ZGF'
  alreadyThere: boolean
  otherOrdersMoving: number
}

function isSwitchPreview(value: unknown): value is SwitchPreview {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  return (
    typeof v.masterCustomerId === 'string' &&
    (typeof v.customerName === 'string' || v.customerName === null) &&
    (v.toEntity === 'TKF' || v.toEntity === 'ZGF') &&
    typeof v.alreadyThere === 'boolean' &&
    typeof v.otherOrdersMoving === 'number'
  )
}

export async function fetchSwitchPreview(id: string, to: 'tkf' | 'zgf'): Promise<SwitchPreview> {
  const res = await secureFetch(`/api/admin/hop-queue/${id}/switch-preview?to=${to}`)
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  const body = (await res.json()) as unknown
  if (!isSwitchPreview(body)) {
    throw new Error('fetchSwitchPreview: unexpected response shape')
  }
  return body
}
